import React from 'react'
import { Body, Button, Heading } from '@dasa-health/alma-react'

// Components
import { BoxDiv, ButtonDiv, ButtonStyled, ContainerGif, ContentDiv, ImagesDiv, SmallParagraph, Title } from './style'
import animation from 'assets/animation.gif'
import logoNav from 'assets/logo.svg'

export interface ParamsBrand {
    logo: string
    brandName: string
}

interface RedirectModalProps {
    paramsBrand?: ParamsBrand
    title: string
    subtitle: string
    labelButton: string
    isSafari: boolean
    redirect: () => void
}

export const RedirectModal: React.VFC<RedirectModalProps> = ({ paramsBrand, title, subtitle, labelButton, isSafari, redirect }) => (
    <BoxDiv className="redirect">
        <ContentDiv>
            <Heading size={'md'} sx={Title}>
                {title}
            </Heading>
            <Body as="p">{subtitle}</Body>
            <ImagesDiv>
                <img alt="Logo laboratório" src={paramsBrand?.logo} />
                <ContainerGif>
                    <img alt="gif de seta apontando para logo" id="gif-style" src={animation} />
                </ContainerGif>
                <img alt="Logo Nav Dasa" id="logo-nav" src={logoNav} />
            </ImagesDiv>
            <Body as="p" sx={SmallParagraph}>
                O Nav Dasa é a plataforma de saúde digital do {paramsBrand?.brandName} e a sua também.
            </Body>
            {isSafari && (
                <ButtonDiv>
                    <Button
                        data-current-service="Página Redirecionamento"
                        data-item-position="Modal Redirecionamento"
                        data-item-text="Agendar pelo Nav Dasa"
                        onClick={redirect}
                        sx={ButtonStyled}
                        type="button"
                        variant="primary"
                    >
                        {labelButton}
                    </Button>
                </ButtonDiv>
            )}
        </ContentDiv>
    </BoxDiv>
)
